'use strict';
angular.module('cvsApp').service('checkStoreopen',['getStoreTiming',function($storetime){
	this.checkOpen = function(item){
		if(item){
			var date = new Date();
			var day = date.getDay();
			var hr = date.getHours();
			var min = date.getMinutes();
			var time = $storetime.getStoreTiming(day,item);
			if(time === "Open 24 Hours"){
				return "<span class='openHrs'>Open</span>";
			}
			var splitime = time.split('-')
			var fromTime = splitime[0];
			var toTime = splitime[1];
			var month = parseInt(date.getMonth())+parseInt(1);
			var currdate = date.getFullYear()+'/'+month+'/'+date.getDate();
			var fromtm = currdate+' '+fromTime;
			var totm = currdate+' '+toTime;
			var from = new Date(Date.parse(fromtm));
			var to = new Date(Date.parse(totm));
			var amPm = '';
			if(hr > 12){
				amPm = 'PM';
			}else{
				amPm = 'AM';
			}
			var hr12form = hr > 12 ? hr-12 : hr;
			var curtime = new Date(Date.parse(currdate+' '+hr12form+':'+min+' '+amPm));
			if(curtime > from && curtime < to){
				return "<span class='openHrs'>Open</span>";
			}else{
				return "<span class='closeHrs'>Closed</span>";
			}
		}
	}
}]);
angular.module('cvsApp').service('getStoreTiming',function(){
	this.getStoreTiming = function(date,store){
		if(store){
			if(!store.content){
				return false;
			}
		  	switch (date) {
			case 7:return store.content.properties.Rx_Sun_Hours.__text;
				break;
			case 1:return store.content.properties.Rx_Mon_Hours.__text;
				break;
			case 2:return store.content.properties.Rx_Tues_Hours.__text;
				break;
			case 3:return store.content.properties.Rx_Wed_Hours.__text;
				break;
			case 4:return store.content.properties.Rx_Thur_Hours.__text;
				break;
			case 5:return store.content.properties.Rx_Fri_Hours.__text;
				break;
			default:return store.content.properties.Rx_Sat_Hours.__text;
				break;
			}
		}

	}
});
angular.module('cvsApp').service('checkFavoriteStore',function(){
	this.favouriteStoreId = [];
	this.setFavouriteStore = function(item){
		this.favouriteStoreId = [];
		this.favouriteStoreId.push(item);
	}
	this.removeFavouriteStore = function(item){
		var itemIdnex = this.favouriteStoreId.indexOf(item);
		if(itemIdnex !=-1){
			this.favouriteStoreId.splice(itemIdnex,1); 
		}
	}
})
